<template>
    <section id="external-activity-container" :class="{'cloaked': isTransitioning}" style="min-height: 100vh">

        <Header :selectedLanguage="selectedLanguage" :activity="activityData" :resetLanguage="resetLanguage" />
        <h3 v-if="(activityData.logo == null || activityData.logo == '')"  class="external-activity--name">{{ activityData.name }}</h3>
        
        <LanguageSelector
            :languages="languagesData"
            :activity="activityData"
            :selectLanguage="selectLanguage"
             v-if="!selectedLanguage"
        />
        <template v-else>
            <template v-if="authed">
                <div v-for="(order, index) in orders">
                    <OrderCard
                        :activity="activity"
                        :order="order"
                        :language="selectedLanguage"
                        :defaultLanguage="defaultLanguage"
                    />
                </div>
            </template>
            <PinAuth v-else :activity="activityData" :user="localUser"/>
        </template>

        <div style="display: flex;justify-content: center;" v-if="Object.keys(localUser ? localUser : {}).length">
            <a href="#" @click.prevent="attemptLogout">Logout</a>
        </div>

        <FooterText :activity="activityData"/>
        <FooterSocials :activity="activityData"/>
    </section>
</template>
<script>
    import FooterText from './Parts/FooterText'
    import FooterSocials from './Parts/FooterSocials'
    import LanguageSelector from './Parts/LanguageSelector'
    import PinAuth from './Parts/PinAuth'
    import Header from './Parts/Header'
    import OrderCard from './Orders/OrderCard'
   
    import EventBus from '../EventBus'

    export default {
        props: [
            'languages',
            'defaultLanguage',
            'termsLink',
            'user',
            'activity'
        ],

        components: {
            FooterText,
            FooterSocials,
            LanguageSelector,
            Header,
            OrderCard,
            PinAuth
        },

        mounted () {
            if (this.languagesData.length === 1) {
                this.selectedLanguage = this.languagesData[0]
            } else {
                if (localStorage.getItem("language") === null){
                    this.selectedLanguage = null
                } else {
                    this.selectedLanguage = JSON.parse(localStorage.getItem("language"))
                    this.selectLanguage(this.selectedLanguage)
                }
            }

            if (this.authed) {
                this.getAccessOrders();
            }
                        
            EventBus.$on('login', (payload) => {
                this.localUser = payload.user;
                this.getAccessOrders();
            })
        },

        methods: {
            selectLanguage(language) {
                this.selectedLanguage = language
                localStorage.setItem("language", JSON.stringify(language))
            },

            resetLanguage(language) {
                this.selectedLanguage = null
                localStorage.removeItem("language")
            },

            attemptLogout() {
                this.logoutError = null;

                window.axios.post(`/${this.activityData.uuid}/logout`, {}).then((response) => {
                    this.localUser = null
                    this.orders = [];
                    EventBus.$emit('login', {
                        user: this.localUser
                    })
                }).catch((err) => {
                    console.log(err.response.data.result)
                    this.logoutError = "Accesso non valido"
                })
            },

            getAccessOrders() {
                if (this.authed) {
                    window.axios.get(`/${this.activityData.uuid}/orders`, {}).then((response) => {
                        this.orders = response.data;
                    }).catch((err) => {
                        this.getAccessOrdersError = "Errore nella consultazione ordini"
                    })
                }
            }
        },

        computed: {
            authed() {
                return !_.isEmpty(this.localUser ?? {});
            }
        },

        data() {
            return {
                localUser: this.user,
                showItem: null,
                parentLabel: null,

                isTransitioning: false,
                selectedLanguage: null,
                activityData: JSON.parse(this.activity),
                languagesData: JSON.parse(this.languages),
                orders: [],

                attemptedContent: null,
                logoutError: null,
                getAccessOrdersError: null
            }
        }
    }
</script>
<style>
    #external-activity-container {
        opacity: 1;
        transition: opacity 200ms;
    }

    #external-activity-container.cloaked {
        opacity: 0;
    }

    div.vue-pincode-input-wrapper {
        width: 100%!important;
    }

    input.vue-pincode-input {
        max-width: 65px!important;
        height: 65px!important;
        font-size: 40px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #f2f2f2!important;
    }

    .slide-up-enter-active {
      transition: all .2s ease;
    }
    .slide-up-leave-active {
      transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-up-enter, .slide-up-leave-to {
      transform: translateY(100vh);
      opacity: 0;
    }
</style>
